import { epic$, store } from '@redux/store';
import {
  postBuildablePlanBrochureEpic,
  postCommunityBrochureEpic,
  postPlanBrochureEpic,
  postSpecBrochureEpic,
  postRecommendedBrochureEpic,
  getRecommendedBrochureEpicPaid,
  getRecommendedBrochureEpicBasic,
  postSpecBrochureBasicEpic,
  postPlanBrochureBasicEpic,
  postCommunityBrochureBasicEpic,
  postBasicLisitingBrochureBasicEpic,
  getBrochureDownloadUrlEpic
} from './redux/epics';
import LeadFormType from './enums/leadFormType';
import brochureSlice from './redux/slices';
import { selectBrochureDetails } from './redux/selectors';
import { postSpecBrochure } from './apis/postBrochure';
import {
  leadOptionSelectedOccurred$,
  leadFormSubmittedOccurred$,
  leadFormClosedOccurred$,
  leadFormAbandonedOccurred$,
  leadFormSubmissionFailedOccurred$,
  notifySubmitClickedOccurred$,
  notifySubmissionFailedOccurred$,
  notifyModalClosedOccurred$,
  notifyAbandonedOccurred$,
} from './redux/trackingObservables';
import {
  trackLeadOptionSelected,
  recordFieldInteraction,
  recordValidationErrors,
  trackLeadFormSubmitted,
  trackLeadFormSubmissionFailed,
  trackLeadFormClosed,
} from './services/leadFormTracking';
import {
  trackNotifyFormOpened,
  recordEmailFieldInteraction,
  trackNotifySubmitClicked,
  trackNotifySubmissionFailed,
  trackNotifyModalClosed,
} from './services/getOnTheListTracking';
import {
  buildFormOpenEvent as buildGoogleAnalytics4FormOpenEvent,
  buildGenerateLeadEvent as buildGoogleAnalytics4GenerateLeadEvent,
  buildFormCloseEvent as buildGoogleAnalytics4FormCloseEvent,
  buildLeadFormAbandonedEvent as buildGoogleAnalytics4LeadFormAbandonedEvent,
  buildLeadFormSubmissionFailedEvent as buildGoogleAnalytics4LeadFormSubmissionFailedEvent,
  buildNotifySubmitClickedEvent as buildGoogleAnalytics4NotifySubmitClickedEvent,
  buildNotifySubmissionFailedEvent as buildGoogleAnalytics4NotifySubmissionFailedEvent,
  buildNotifyModalClosedEvent as buildGoogleAnalytics4NotifyModalClosedEvent,
  buildNotifyAbandonedEvent as buildGoogleAnalytics4NotifyAbandonedEvent,
} from './services/googleAnalytics4EventBuilder';
import {
  buildLeadButtonClickedEvent as buildSegmentLeadButtonClickedEvent,
  buildLeadModalFormSubmittedEvent as buildSegmentLeadModalFormSubmittedEvent,
  buildLeadModalClosedEvent as buildSegmentLeadModalClosedEvent,
  buildLeadFormAbandonedEvent as buildSegmentLeadFormAbandonedEvent,
  buildLeadFormSubmissionFailedEvent as buildSegmentLeadFormSubmissionFailedEvent,
  buildNotifySubmitClickedEvent as buildSegmentNotifySubmitClickedEvent,
  buildNotifySubmissionFailedEvent as buildSegmentNotifySubmissionFailedEvent,
  buildNotifyModalClosedEvent as buildSegmentNotifyModalClosedEvent,
  buildNotifyAbandonedEvent as buildSegmentNotifyAbandonedEvent,
} from './services/segmentEventBuilder';

const { actions: brochureSliceActions, reducer: brochureSliceReducers } = brochureSlice;

let initialized = false;

/**
 * Runs this feature's side effects (epic registration, wrapper.js's global click delegation,
 * pdfBrochureHandler, the brochureDownloadUrl reducer injection) exactly once. Callers must
 * invoke this explicitly — merely importing this module never runs it, so a page that only needs
 * e.g. LeadFormType or the tracking Subjects/builders (Community Detail's own eventTracking
 * files, for instance) can import this barrel unconditionally without those side effects reaching
 * pages that never actually open a lead form. Idempotent: safe to call from multiple components
 * that each independently need this feature active on the same page (Search Results'
 * standardCard.js/summaryCard.js, rendered once per card, both call this).
 */
export function setupLeadGenerators() {
  if (initialized) {
    return;
  }

  epic$.next(postBuildablePlanBrochureEpic);
  epic$.next(postCommunityBrochureEpic);
  epic$.next(postPlanBrochureEpic);
  epic$.next(postSpecBrochureEpic);
  epic$.next(postRecommendedBrochureEpic);
  epic$.next(getRecommendedBrochureEpicPaid);
  epic$.next(getRecommendedBrochureEpicBasic);
  epic$.next(postSpecBrochureBasicEpic);
  epic$.next(postPlanBrochureBasicEpic);
  epic$.next(postCommunityBrochureBasicEpic);
  epic$.next(postBasicLisitingBrochureBasicEpic);
  epic$.next(getBrochureDownloadUrlEpic);

  require('./components/wrapper');
  require('./components/pdfBrochureHandler');

  store.injectReducer('brochureDownloadUrl', brochureSliceReducers);

  initialized = true;
}

export {
    brochureSliceActions,
    brochureSliceReducers,
    selectBrochureDetails,
    postSpecBrochure,
    leadOptionSelectedOccurred$,
    leadFormSubmittedOccurred$,
    leadFormClosedOccurred$,
    leadFormAbandonedOccurred$,
    leadFormSubmissionFailedOccurred$,
    trackLeadOptionSelected,
    recordFieldInteraction,
    recordValidationErrors,
    trackLeadFormSubmitted,
    trackLeadFormSubmissionFailed,
    trackLeadFormClosed,
    buildGoogleAnalytics4FormOpenEvent,
    buildGoogleAnalytics4GenerateLeadEvent,
    buildGoogleAnalytics4FormCloseEvent,
    buildGoogleAnalytics4LeadFormAbandonedEvent,
    buildGoogleAnalytics4LeadFormSubmissionFailedEvent,
    buildSegmentLeadButtonClickedEvent,
    buildSegmentLeadModalFormSubmittedEvent,
    buildSegmentLeadModalClosedEvent,
    buildSegmentLeadFormAbandonedEvent,
    buildSegmentLeadFormSubmissionFailedEvent,
    notifySubmitClickedOccurred$,
    notifySubmissionFailedOccurred$,
    notifyModalClosedOccurred$,
    notifyAbandonedOccurred$,
    trackNotifyFormOpened,
    recordEmailFieldInteraction,
    trackNotifySubmitClicked,
    trackNotifySubmissionFailed,
    trackNotifyModalClosed,
    buildGoogleAnalytics4NotifySubmitClickedEvent,
    buildGoogleAnalytics4NotifySubmissionFailedEvent,
    buildGoogleAnalytics4NotifyModalClosedEvent,
    buildGoogleAnalytics4NotifyAbandonedEvent,
    buildSegmentNotifySubmitClickedEvent,
    buildSegmentNotifySubmissionFailedEvent,
    buildSegmentNotifyModalClosedEvent,
    buildSegmentNotifyAbandonedEvent,
};

export default LeadFormType;
